import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import { ChakraProvider } from "@chakra-ui/react";
import { BrowserRouter as Router } from 'react-router-dom';
import AppProvider from "./context/index.tsx";
import "./global.css";
import './i18n'; // Import your i18n configuration

import { theme, lightModeManager } from './theme';

ReactDOM.createRoot(document.getElementById("root")!).render(
  <ChakraProvider theme={theme} colorModeManager={lightModeManager}>
    <React.StrictMode>
      <AppProvider>
      <Router>
        <App />
        </Router>
      </AppProvider>
    </React.StrictMode>
  </ChakraProvider>
);
